import React, { useState, useEffect } from "react";
import { getCookies } from "../controllers/cookies.controller";
import globals from "../globals";

import Header from "../components/Header";

import planLivreImg from "../img/2k20-livre.svg";
import planTotalImg from "../img/2k20-total.svg";

import "../styles/resume.css";

interface ApiResponse {
    status: string;
    registro: {
        token: string;
        status: number;
        nome: string;
        tipo_pessoa: string;
        telefone: string;
        telefone_fixo: string;
        email: string;
        cnpj_cpf: string;
        rg: string;
        data_nascimento: string;
        id_vendedor: string;
        url_assinatura_digital: string | null;
        pdf_contrato: string;
        plano: {
            id: number;
            status: boolean;
            empresa: number;
            regiao: number;
            id_plano: number;
            nome: string;
            tipo_pessoa: string;
            valor: number;
            valorInstalacao: number;
            valor_anterior: number;
            download: string;
            upload: string;
            descricaoSla: string;
            extra: string;
            cor_background: string;
        };
        serv_ad: {
            id: number;
            nome: string;
            valor_unitario: string;
        }[];
        total: number;
    };
}

const Resume = () => {
    const [resumeData, setResumeData] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            const cookieData = getCookies("planData");
            const registroToken = cookieData ? cookieData.registroToken : "";

            const response = await fetch(`${globals.apiBaseUrl}/api/streaming`, {
                method: "POST",
                headers: {
                    'Authorization': globals.token,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: registroToken, // This token identifies the user/session
                    route: "get_registro",
                }),
            });

            const result: ApiResponse = await response.json();
            setResumeData(result);
            setLoading(false);
        };

        fetchData();
    }, []);

    const isPLanTotal = resumeData?.registro.plano.nome === "Plano Total";

    if (loading || !resumeData) {
        return (
            <React.Fragment>
                <Header/>
                <div className="resume-container">
                    <b>Carregando...</b>
                </div>
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <Header/>
            <div className="confetti"></div>
            <div className="resume-container">
                <b className="header">Obrigado por escolher a 2KPLAY</b>

                <div className="plan-card">
                    <div className="top">
                        <div className="separator">
                            <b>Informações da sua <br />assinatura:</b>
                            <div className="client-info">
                                <span>Nome: {resumeData.registro.nome}</span>
                                <span>CPF/CNPJ: {resumeData.registro.cnpj_cpf}</span>
                                <span>Email: {resumeData.registro.email}</span>
                                <span>Telefone: {resumeData.registro.telefone}</span>
                            </div>
                        </div>
                        <div className="separator">
                            <img src={isPLanTotal?  planTotalImg : planLivreImg} className="plan-logo" alt="plan logo" />
                            
                            {
                                isPLanTotal ? <div className="benefits-wrapper">
                                    <div className="benefit-row">🖥️ <span>Mais de 100 canais</span> (incluindo canais locais)</div>
                                    <div className="benefit-row">🎬 <span>Acesso ilimitado a filmes e séries</span></div>
                                    <div className="benefit-row">⏪ <span>Voltar conteúdo ao vivo</span> para assistir o que já passou</div>
                                    <div className="benefit-row">📱 <span>Até 5 dispositivos simultâneos</span></div>
                                </div>
                                : <div className="benefits-wrapper">
                                    <div className="benefit-row">🖥️ <span>Mais de 40 canais</span> (incluindo canais locais)</div>
                                    <div className="benefit-row">▶️ <span>Filmes e séries sob demanda</span></div>
                                    <div className="benefit-row">⏪ <span>Voltar conteúdo ao vivo</span> para assistir o que já passou</div>
                                    <div className="benefit-row">📱 <span>Até 3 dispositivos simultâneos</span></div>
                                </div>
                            }
                            {resumeData.registro.serv_ad && resumeData.registro.serv_ad.length > 0 && (
                                <div className="benefits-wrapper">
                                    <div className="benefit-row" style={{marginTop: "1rem"}}><b>Serviços Adicionais:</b></div>
                                    {resumeData.registro.serv_ad.map((service: any) => (
                                        <div className="benefit-row" key={service.id}>
                                            <span>{service.nome}</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                    <span className="total">Total: {resumeData.registro.total.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</span>
                </div>

                <a href="/">Nova assinatura</a>
            </div>
        </React.Fragment>
    )   
}

export default Resume;